import { render, staticRenderFns } from "./modal-nova-conversa.vue?vue&type=template&id=211c139f&scoped=true&"
import script from "./modal-nova-conversa.vue?vue&type=script&lang=js&"
export * from "./modal-nova-conversa.vue?vue&type=script&lang=js&"
import style0 from "./modal-nova-conversa.vue?vue&type=style&index=0&id=211c139f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c139f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211c139f')) {
      api.createRecord('211c139f', component.options)
    } else {
      api.reload('211c139f', component.options)
    }
    module.hot.accept("./modal-nova-conversa.vue?vue&type=template&id=211c139f&scoped=true&", function () {
      api.rerender('211c139f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-nova-conversa/modal-nova-conversa.vue"
export default component.exports